import { Controller } from 'stimulus';

// Builder-side picker for a task-parameter section's conditional visibility.
// Given a map of dropdown-parameter id -> options, it renders the checkbox list
// of values for whichever parent parameter is selected. Submitting posts the
// checked values as task_parameter_section[condition_values][].
export default class extends Controller {
  static targets = ['parentSelect', 'conditionContainer', 'conditionCheckboxes']

  connect() {
    this.optionsMap = JSON.parse(this.data.get('optionsMap') || '{}');
    this.selectedValues = JSON.parse(this.data.get('selected') || '[]').map(String);
    this.render();
  }

  // When the parent parameter changes, the previously-checked values no longer
  // apply, so start fresh.
  parentChanged() {
    this.selectedValues = [];
    this.render();
  }

  render() {
    const parentId = this.parentSelectTarget.value;
    this.conditionCheckboxesTarget.innerHTML = '';

    if (!parentId) {
      this.conditionContainerTarget.classList.add('hidden');
      return;
    }

    const options = this.optionsMap[parentId] || [];
    this.conditionContainerTarget.classList.remove('hidden');

    options.forEach((option) => {
      const label = document.createElement('label');
      label.className = 'flex items-center gap-2 text-sm';

      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.name = 'task_parameter_section[condition_values][]';
      checkbox.value = option;
      checkbox.className = 'form-checkbox h-4 w-4 text-blue-600';
      if (this.selectedValues.includes(String(option))) {
        checkbox.checked = true;
      }

      const span = document.createElement('span');
      span.textContent = option;

      label.appendChild(checkbox);
      label.appendChild(span);
      this.conditionCheckboxesTarget.appendChild(label);
    });
  }
}
